import React, { useEffect, useState } from 'react';
import Layout from '../../parts/Layout';
import { httpRequest } from '../../../services/httpService';
import helpers from '../../../services/helpers';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import Loader from '../../parts/Loader';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import DropDownSelection from '../../elements/DropDownSelection';

import Dropdown from 'react-bootstrap/Dropdown'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import initTreeView from '../../../services/initTreeView';
import store from '../../../services/store';
import { TbChecklist, TbCalendar , TbEdit, TbTrash, TbFileTypePdf, TbCancel  } from "react-icons/tb";
import { LiaFileSignatureSolid } from "react-icons/lia";
import {getEnums, getData, getApiData, postApiData, getServiceHubEnums } from '../../../services/apiService';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
 
export default function ServiceRequestList ({view = 'all', menu = 'manage-service-requests', page_title = "Service Request", parent_text = "PolarServ"}, ){
    const [record_data, setRecordData] = useState([]);
    const [loading, setLoading] = useState(1);
    const [enums, setEnums] = useState(store.order_enums);
    const [search_key, setSearchKey] = useState('');
    const [prompt_modal, setPromptModal] = useState(0);
    const [prompt_title, setPromptTitle] = useState('');
    const [prompt_caption, setPromptCaption] = useState('');
    const [prompt_error, setPromptError] = useState('');
    const [reasons_list, setResons] = useState();
    const [selected_reason, setSelectedReason] = useState('');
    const [order_id, setOrderID] = useState('');
    const [data_table, setDataTable] = useState([]);
    const [selected_items, setSelectedItems] = useState([]);
    const [selected_all, setSelectAll] = useState(false);
    const [datatable_state, setDataTableState] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null
    });
    const [filters, setFilters] = useState({
        status: "",
        search: "",
        service_type: "",
        sub_service_type: "",
        request_dates: "",
        schedule_dates: ""
    });

    useEffect(() => {
        initTreeView()
        fetchDataList({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows
        })
        
        const fetchEnums = async () => {
            setLoading(true)
            const res = await getServiceHubEnums()
            if(res.status === 'success'){
                setEnums(res.data)
                setLoading(0)
            }
        }
        fetchEnums()
    }, []);

    useEffect(() => {
        clearFilters()
    }, [view]);

    
    function inputDateChange(e){
        let { name, value } = e.target;
        let new_state = { [name] : value }

        if(!value){
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            new_state = { name: [firstDay, lastDay] }
        }

        setFilters({ ...filters, ...new_state });
    }
        

    useEffect(() => {
        displayDataTable(record_data)
    }, [datatable_state.sortOrder]);

    useEffect(() => {
        displayDataTable(record_data)
    }, [
        selected_items, 
        selected_all
    ]);

    useEffect(() => {
        fetchDataList({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows,
            //"search": search_key
        })
    }, [datatable_state, filters]);
    
    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;

                if(name == 'warranty_status') value = 'active'
            } else {
                value = 0;

                if(name == 'warranty_status') value = 'expired'
            }
        }
        else if (e.target.type === "file") {
          value = e.target.files[0]
        }

        let new_state = { [name]: value }

        setFilters({ ...filters, ...new_state });
    }

    async function fetchDataList(condition = {
        "page": '',
        "search": '',
        "per_page": ''
    }){
        const page = condition.page ?? datatable_state.page
        const per_page = condition.per_page ?? datatable_state.rows
        const search = condition.search ?? search_key
        //let filter = `?store_id=${helpers.getStoreID()}&`
        let filter = `?paginate=1&`

        if(page){
            filter += 'page='+page+'&'
        }
        if(per_page){
            filter += 'per_page='+per_page+'&'
        }
        if(filters.search){
            filter += 'search='+filters.search+'&'
        }
        if(filters.status){
            filter += 'status='+filters.status+'&'
        }
        if(filters.service_type){
            filter += 'service_type='+filters.service_type+'&'
        }
        if(filters.sub_service_type){
            filter += 'sub_service_type='+filters.sub_service_type+'&'
        }

        if(filters.request_dates && filters.request_dates?.[1]){
            filter += `request_from=${helpers.formatDate(filters.request_dates[0])}&request_to=${helpers.formatDate(filters.request_dates[1])}&`
        }
        if(filters.schedule_dates && filters.schedule_dates?.[1]){
            filter += `schedule_from=${helpers.formatDate(filters.schedule_dates[0])}&schedule_to=${helpers.formatDate(filters.schedule_dates[1])}&`
        }

        if(view === 'assigned'){
            filter += `filter=assigned&`
        }

        filter = filter.slice(0, -1)

        // setLoading(1)
        let endpoint = helpers.createServiceHubUrl(`v1/service-requests${filter}`)
        const data = await getApiData(endpoint)

        if(data){
            setLoading(0)
            setRecordData(data)
            displayDataTable(data)
        }
    }

    async function deleteItem(ids){
        let endpoint = helpers.createServiceHubUrl(`v1/product-details/delete`)
        const res = await postApiData(endpoint, {"ids": ids})

        if(res.status === 'success'){
            fetchDataList()
            setSelectedItems([])

            Swal.fire({
                title: "Success",
                text: res.message,
                icon: "success",
                confirmButtonText: "OK",
            })
        }
                
        if(res.status === 'error'){
            setSelectedItems([])

            Swal.fire({
                text: res.message,
                //text: err.message,
                icon: "error",
                confirmButtonText: "OK",
            })
        }
    }
    

    function search(e){
        let { value } = e.target;
        setSearchKey(value)
        fetchDataList({
            "page": datatable_state.page + 1,
            "search": value
        })
    }

    function triggerAction(data, status, action = ''){
        if(status > 0){
            if(status === 10){
                Swal.fire({
                    title: 'Cancel Service Request',
                    text: 'This action cannot be reversed. Do you want to continue?',
                    showCancelButton: true,
                    showConfirmButton: false,
                    closeOnCancel: true,
                    showDenyButton: true,
                    denyButtonText: 'Yes'
                })
                .then((result) => {
                    if (result.isDenied) {
                        updateStatusItem(data, status)
                    }
                })
                return
            }

            updateStatusItem(data, status)
        }
    }

    async function updateStatusItem(id, status){
        let form_data = {
            service_id: id,
            status: status
        }

        let endpoint = helpers.createServiceHubUrl(`v1/service-requests/update-status`)
        const res = await postApiData(endpoint, form_data)
        
        setLoading(0)
        if(res.status === 'error'){
            Swal.fire({
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            return
        }
        
        Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            confirmButtonText: "OK",
            allowOutsideClick: false
        })
        .then((result) => {
            if (result.isConfirmed) {;
                fetchDataList()
                setSelectedItems([])
            }
        })
    }

    function displayDataTable(data){
        setDataTable(
            <DataTable 
                className='border-top'
                dataKey={data?.id}
                value={data?.data} 
                size="small"
                paginator 
                rows={data?.per_page} 
                rowsPerPageOptions={[5, 10, 20, 25, 50]}
                totalRecords={data?.total}
                onPage={onPage}
                first={datatable_state.first}
                lazy
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                selection={selected_items} 
                onSelectionChange={onSelectItem}
                scrollHeight="500px"
                scrollable
                responsive={true}
                emptyMessage="No data to display"
            >
                <Column className="text-center" body={displayActionMenu} headerStyle={{ width: '8rem' }}  alignHeader="center"
                    header={() => <Link className='btn btn-primary btn-sm w-full' to="/polarserv/service-requests/new"><i className="fas fa-plus-circle mr-2" />New</Link>}
                >
                </Column> 
                <Column field="id" header="ID" />
                <Column header="Service&nbsp;No" body={({id, service_no})=> 
                    view === 'assigned' ?  
                    <Link to={`/polarserv/service-requests/schedule/${id}`}>{service_no}</Link>:
                    <Link to={`/polarserv/service-requests/${id}`}>{service_no}</Link>
                }></Column>
                {view === 'assigned' && <Column field="schedule_date" header="Schedule Date" />}
                <Column field="request_date" header="Request Date" ></Column>
                <Column header="Customer" body={({customer_id, customer_name})=> <Link to={`/customers/${customer_id}/edit`}>{customer_name}</Link>}></Column>
                <Column field="service_type_name" header="Service Type" body={({service_type_name, sub_service_type_name})=> helpers.concatenateText([service_type_name, sub_service_type_name], ' / ')} ></Column>
                <Column header="Status" body={({status, status_name})=> <h5>{helpers.displayServiceRequestStatusBadge(status, status_name)}</h5>}></Column>
            </DataTable>
        )

    }

    const onPage = (e) => {
        setDataTableState(e)
        setSelectedItems([])
    };

    const onSelectItem = (e) => {
        const value = e.value;
        setSelectedItems(value);
    };

    function displayActionMenu(data){
        return (<Dropdown>
                        <Dropdown.Toggle className='btn-light border' size="sm" id={"dropdown-actions-"+data.id}>Action</Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                            {  
                                parseInt(data.status) === 4 ? 
                                 <Dropdown.Item key="in-progress" onClick={(e) => triggerAction(data.id, 5, 'in-progress')}><i className="fas fa-check-circle mr-2" style={{width: '20px'}} />Start Service</Dropdown.Item> : ''
                            }
                            {  
                                parseInt(data.status) === 5 ? 
                                 <Dropdown.Item key="complete" onClick={(e) => triggerAction(data.id, 6, 'service')}><i className="fas fa-check-circle mr-2 text-success" style={{width: '20px'}} />Ready for Acceptance</Dropdown.Item> : ''
                            }
                            {  
                                (parseInt(data.status) === 2 || parseInt(data.status) === 3) && view !== 'assigned' ? 
                                <Dropdown.Item key="schedule" as={Link}  to={`/polarserv/service-requests/${data.id}/schedule`}><TbCalendar  size={20} className='mr-2'/>Service Schedule</Dropdown.Item> : ''
                            }
                            {  
                                parseInt(data.status) === 3 || parseInt(data.status) === 4 ? 
                                <Dropdown.Item key="assessment" as={Link}  to={`/polarserv/service-requests/${data.id}/assessment`}><TbChecklist size={20} className='mr-2'/>Assessment
                                </Dropdown.Item> : ''
                            }
                            {  
                                parseInt(data.status) === 3 || parseInt(data.status) === 4 || parseInt(data.status) === 5 || parseInt(data.status) === 6 || parseInt(data.status) === 7 ? 
                                <Dropdown.Item key="acceptance" as={Link}  to={`/polarserv/service-requests/${data.id}/acceptance`}><LiaFileSignatureSolid size={20} className='mr-2'/>Acceptance
                                </Dropdown.Item> : ''
                            }
                            
                            {
                                view !== 'assigned' ?
                                <Dropdown.Item key="job-order" as={Link}  to={`/polarserv/service-requests/${data.id}/print`} target='new'><TbFileTypePdf size={20} className='mr-2'/>Print Job Order</Dropdown.Item> : ''
                            }

                            {
                                parseInt(data.status) === 8 ?
                                <Dropdown.Item key="print-accetance" as={Link}  to={`/polarserv/service-requests/${data.id}/print-acceptance`} target='new'><TbFileTypePdf size={20} className='mr-2'/>Print Acceptance Form</Dropdown.Item> : ''
                            }
            
                            {
                                parseInt(data.status) != 8 && parseInt(data.status) !== 9 && parseInt(data.status) !== 10 && view !== 'assigned' ?
                                <Dropdown.Item key="edit" as={Link}  to={`/polarserv/service-requests/${data.id}/form`}><TbEdit size={20} className='mr-2' />Edit</Dropdown.Item> : ''
                            }
                            {
                                parseInt(data.status) != 8 && parseInt(data.status) !== 9 && parseInt(data.status) !== 10 && view !== 'assigned' ?
                                <Dropdown.Item key="in-progress" onClick={(e) => triggerAction(data.id, 10, 'cancel')}><TbCancel size={20} className='mr-2 text-danger' />Cancel Request</Dropdown.Item> : ''
                            }
                        </Dropdown.Menu>
                    </Dropdown>)
    }

    function clearFilters(){
        setFilters({
            status: "",
            search: "",
            service_type: "",
            sub_service_type: "",
            request_dates: "",
            schedule_dates: ""
        })
    }

    return (
        <Layout parent_text={parent_text} page_title={page_title} menu={menu}>
            <div className="container-fluid" style={{position: 'relative'}}>
                <Loader isLoading={loading}/>

                <div className="card">
                    <div className="card-header border-0 p-0">

                        <Accordion className='polarserv-filters'>
                            <AccordionTab header="Filters" className="text-dark rounded-0" contentClassName="border-0 rounded-0" unstyled={true}>
                                <div className="row">
                                    <div className="col-lg-3 mb-3">
                                        <label>Service Type</label>
                                        <DropDownSelection
                                            tagClass="form-control mb-2"
                                            id="service_type"
                                            name='service_type' 
                                            placeholder='Select Service Type'
                                            value={filters.service_type}  
                                            onChange={inputChange}
                                            onFocus=""
                                            optionList={enums?.service_types}
                                            optionProps ={{value:'id', label:'service_type_name'}}
                                        />
                                        <DropDownSelection
                                            tagClass="form-control"
                                            id="sub_service_type"
                                            name='sub_service_type' 
                                            placeholder='Sub Service Type'
                                            value={filters.sub_service_type}  
                                            onChange={inputChange}
                                            onFocus=""
                                            optionList={enums?.service_types}
                                            optionProps ={{value:'id', label:'service_type_name'}}
                                        />
                                    </div>
                                    <div className="col-lg-3 mb-3 mb-lg-0">
                                        <label>Status</label>
                                        <DropDownSelection
                                            tagClass="form-control"
                                            id="status"
                                            name='status' 
                                            placeholder='Select Status'
                                            value={filters.status}  
                                            onChange={inputChange}
                                            onFocus=""
                                            optionList={enums?.service_status}
                                            optionProps ={{value:'id', label:'status_name'}}
                                        />
                                    </div>
                                    <div className="col-md-4 col-lg-3 mb-2">
                                        <label>Request Dates</label><br/>
                                        <Calendar 
                                            name="request_dates"
                                            value={filters.request_dates} 
                                            onChange={inputDateChange} 
                                            dateFormat="yy-mm-dd"
                                            selectionMode="range" 
                                            readOnlyInput 
                                            hideOnRangeSelection 
                                            className='w-100'
                                            showButtonBar
                                            placeholder='Request Date Range'
                                            showIcon
                                        />
                                    </div> 
                                    <div className="col-md-4 col-lg-3 mb-3">
                                        <label>Schedule Dates</label><br/>
                                        <Calendar 
                                            name="schedule_dates"
                                            value={filters.schedule_dates} 
                                            onChange={inputDateChange} 
                                            dateFormat="yy-mm-dd"
                                            selectionMode="range" 
                                            readOnlyInput 
                                            hideOnRangeSelection 
                                            className='w-100'
                                            showButtonBar
                                            placeholder='Schedule Date Range'
                                            showIcon
                                        />
                                    </div> 
                                    <div className="col-md-4 col-lg-3 mb-2">
                                        <label>Search</label>
                                        <InputText
                                            id="search" 
                                            name="search" 
                                            value={filters.search}
                                            tagClass="form-control mb-0"
                                            placeholder="Search"
                                            onChange={inputChange}
                                            className='w-100'
                                        />
                                    </div>
                                    <div className="col-12 mt-2">
                                        <butto type="button" className="btn btn-outline-dark float-right" onClick={()=>clearFilters()}>Clear Filters</butto>
                                    </div>
                                </div>
                            </AccordionTab>
                        </Accordion>

                    </div>
                    {/* <div className="card-header border-bottom-0">
                        <div className="row">
                            <div className="col-lg-8 mb-2">
                                <div className="row">
                                    <div className="col-lg-3 mb-3 mb-lg-0">
                                        <DropDownSelection
                                            tagClass="form-control"
                                            id="status"
                                            name='status' 
                                            placeholder='Select Status'
                                            value={filters.status}  
                                            onChange={inputChange}
                                            onFocus=""
                                            optionList={enums?.service_status}
                                            optionProps ={{value:'id', label:'status_name'}}
                                        />
                                    </div>
                                    <div className="col-lg-3 mb-3 mb-lg-0">
                                        <DropDownSelection
                                            tagClass="form-control"
                                            id="service_type"
                                            name='service_type' 
                                            placeholder='Select Service Type'
                                            value={filters.service_type}  
                                            onChange={inputChange}
                                            onFocus=""
                                            optionList={enums?.service_types}
                                            optionProps ={{value:'id', label:'service_type_name'}}
                                        />
                                    </div>
                                    <div className="col-lg-3">
                                        <input type="text" name="search" className="form-control" placeholder="Search" onChange={inputChange} />
                                    </div>
                                    <div className="col-lg-3">
                                        <button type="button" className='btn btn-outline-dark' onClick={() =>clearFilters()}>Clear</button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 text-right mt-3 mt-md-0">
                                <Link className='btn btn-primary float-right' to="/polarserv/service-requests/new"><i className="fas fa-plus-circle mr-2" />New</Link>
                                
                                {selected_items.length ?
                                <Dropdown className='float-right mr-3'>
                                    <Dropdown.Toggle className='btn-light border' id={"dropdown-actions-"}>Bulk Action</Dropdown.Toggle>
                                    <Dropdown.Menu align="end">
                                        <Dropdown.Item key="delete" className='text-danger' onClick={(e) => triggerAction(selected_items, 0, 'bulk-delete')}><TbTrash size={20} className='mr-2' />Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> : ''}
                            </div>
                        </div>
                    </div> */}
                    <div className="card-body p-0">
                        { data_table }
                    </div>
                </div>
            </div>
        </Layout>
    )
}